/* Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { If, Then, Else } from "react-if";
import { Text } from "@nordcloud/gnui";
import { Provider, useSkuCostsQuery } from "~/generated/graphql";
import { LoaderWrap, NoData, ReactTable } from "~/components";
import { isNotEmpty } from "~/tools";
import { SKU_COSTS_COLUMNS } from "./SkuCostColumns";

type Props = {
  nid: string | undefined;
  provider: Provider | undefined;
};

export function SkuCostsList({ nid, provider }: Props) {
  const { data, loading } = useSkuCostsQuery({
    variables: {
      nid: nid ?? "",
      providers: provider,
    },
  });

  const skuCosts = React.useMemo(() => {
    return data?.skuCosts?.currentMonth ?? [];
  }, [data]);

  const showSkuCosts = isNotEmpty(skuCosts);

  return (
    <LoaderWrap loading={loading} inContent>
      <If condition={showSkuCosts}>
        <Then>
          <ReactTable columns={SKU_COSTS_COLUMNS} data={skuCosts} striped />
        </Then>
        <Else>
          <NoData message={<Text>There are no SKUs data.</Text>} />
        </Else>
      </If>
    </LoaderWrap>
  );
}
